import React from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { useTier } from '../context/TierContext';
import { TENANT_TIER_OPTIONS, TenantTier } from '../constants/tenantTiers';

/**
 * Prod / Dev segmented switch in the top nav. Every page reads the same
 * selection, so the UI is identical and only the tenants behind it change.
 * On a client drill-down the client belongs to one tier, so switching goes
 * back to the clients list of the newly selected tier.
 */
export default function TierSwitch() {
  const { tier, setTier } = useTier();
  const navigate = useNavigate();
  const onClientDetail = useMatch('/clients/:tenantId');

  const handleSelect = (next: TenantTier) => {
    if (next === tier) return;
    setTier(next);
    if (onClientDetail) navigate('/clients');
  };

  // One served tier means nothing to switch: show it as a plain label.
  if (TENANT_TIER_OPTIONS.length === 1) {
    return (
      <div className="tier-switch" role="group" aria-label="Tenant tier">
        <span className="tier-switch-option on" aria-current="true">
          {TENANT_TIER_OPTIONS[0].label}
        </span>
      </div>
    );
  }

  return (
    <div className="tier-switch" role="radiogroup" aria-label="Tenant tier">
      {TENANT_TIER_OPTIONS.map((option) => (
        <button
          key={option.tier}
          type="button"
          role="radio"
          aria-checked={tier === option.tier}
          title={option.description}
          className={
            'tier-switch-option' +
            (tier === option.tier ? ' on' : '') +
            (option.tier === TenantTier.Dev ? ' is-dev' : '')
          }
          onClick={() => handleSelect(option.tier)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
